import React from "react";
import { Box, Title } from "rizzui";

interface SidebarNavigationProps {
  activeSection: string;
  onSectionChange: (section: string) => void;
}

const sections = [
  { id: "bsd", label: "BSD Rates", icon: "💰" },
  { id: "absd", label: "ABSD Rates", icon: "🏠" },
  { id: "ltv", label: "LTV Limits", icon: "📊" },
  { id: "ssd", label: "SSD Rates", icon: "🔄" },
];

const SidebarNavigation: React.FC<SidebarNavigationProps> = ({
  activeSection,
  onSectionChange,
}) => {
  return (
    <div className="lg:col-span-1">
      <nav className="space-y-2 md:mt-6">
        {sections.map((section) => (
          <button
            key={section.id}
            onClick={() => onSectionChange(section.id)}
            className={`w-full text-left px-3 py-2 rounded-md text-sm transition-colors ${
              activeSection === section.id
                ? "bg-primary text-primary-foreground"
                : "hover:bg-gray-100"
            }`}
          >
            <span className="mr-2">{section.icon}</span>
            {section.label}
          </button>
        ))}
      </nav>
    </div>
  );
};

export default SidebarNavigation;
